//将拦截器整体导入
import request from './interceptor'//导入已经写好的拦截器

const api = {
    //region get类型的api
    /**
     * 获取模型类型
     */
    modelType:function () {
        console.log('api:modelType  --');
        return request({
            url:'api/Model/modeltype',
            method:'get',
        });
    },
    /**
     * 获取葫芦品牌
     */
    hlbrand:function () {
        console.log('api:hlbrand  --');
        return request({
            url:'/api/Model/hlbrand',
            method:'get',
        });
    },
    /**
     * 批量下载接口
     * @param username 用户名
     * @param file 项目号
     * @param modelName 模型名称
     * @param saveAs
     * @returns {*}
     */
    batchDownload:function (username,file,modelName,saveAs) {
        return request({
            url:'/api/Model/hlbrand',
            method:'get',
            param:{UserName:username,file,ModelName:modelName,saveAs}
        });
    },
    //endregion

    //region post类型的api

    /**
     * 加载模型输入参数
     * @param {string} modelType 模型类型，示例值：横梁自立式 WFT
     * @param {string} username 用户名
     */
    input:function (modelType,userName) {
        console.log('api:input  --','data:modelType:',modelType,'userName:',userName);
        return request({
            url:'api/Model/input',
            method:'post',
            data:{modelType,userName}
        });
    },
    /**
     * 提交模型参数
     * @param {string} type 模型类型
     * @param {string} username 用户名
     * @param {string} projectName 项目名称
     * @param {Object} data 模型数据
     * @param {string} username 用户名
     * @returns {AxiosPromise}
     */
    postModel: function (type,username,projectName,data) {
        console.log('api:postModel  --','data:',data);
        return request({
            url:'api/Model/postModel',
            method:'post',
            data:{type,username,projectName,input:{doc:data}}
        });
    },
    /**
     * 获取模型订单列表
     * @param {Number} limit 一页多少数据
     * @param {Number} page 当前页码
     * @returns {*}
     */
    modelList: function (limit,page) {
        console.log('api:modelList  --','data:','limit:',limit,'page:',page);
        return request({
            url:'/api/Order/order',
            method:'post',
            data:{limit,page}
        });
    },
    /**
     * 获取葫芦型号
     * @param {string} brand 葫芦品牌
     * @param {string} smallvehicle 小车运行
     * @param {string} load 载荷
     */
    hllist:function (brand,smallvehicle,load) {
        console.log('api:hllist  --','data: ',`brand:${brand},smallvehicle:${smallvehicle},load:${load}`);
        return request({
            url:'/api/Model/hllist',
            method:'post',
            data:{brand:brand,smallvehicle:smallvehicle,load:load}
        });
    },
    /**
     * 获取葫芦参数
     * @param {string} brand 葫芦品牌
     * @param {string} type 模型类型
     */
    hldata:function (brand,type) {
        console.log('api:hldata  --','data: ',`brand:${brand},type:${type}`);
        return request({
            url:'/api/Model/hldata',
            method:'post',
            data:{brand:brand,type:type}
        });
    },
    /**
     * 校验模型项目号
     * @param {string} pjname 项目号
     */
    checkpjname:function (pjname) {
        console.log('api:input  --','data: ',`pjname:${pjname}`);
        return request({
            url:'api/Model/checkpjname',
            method:'post',
            data:{pjname:pjname}
        });
    },
    /**
     * 用户登录
     * @param {string} username
     * @param {string} password
     * @returns {*}
     */
    login:function (username,password) {
        console.log('api:login  --','data: ',`username:${username},password:${password}`);
        return request({
            url:'api/Login/login',
            method:'post',
            data:{username,password}
        });
    },
    /**
     * 用户注册
     * @param {string} username 用户名
     * @param {string} password 密码
     * @param {string} telephone 手机号
     * @param {string} mailbox 邮箱
     * @param {string} company 公司名称
     * @returns {*}
     */
    regist:function (username,password,telephone,mailbox,company) {
        console.log('api:login  --','data: ',`username:${username},password:${password},telephone:${telephone},mailbox:${mailbox},company:${company}`);
        return request({
            url:'api/Login/regist',
            method:'post',
            data:{username,password,telephone,mailbox,company}
        });
    },

    /**
     * 获取验证码
     * @param {string|null} username 用户名
     * @param {string|null} telephone 手机号
     * @returns {*}
     */
    getCheckCode:function (username,telephone) {
        console.log('api:getCheckCode  --','data: ',`telephone:${telephone},username:${username}`);
        let data = null;
        if (username!==null) data = {username};
        else if(telephone!==null) data = {telephone};

        return request({
            url:'api/Login/codequery',
            method:'post',
            data:data
        });
    },
    /**
     * 校验验证码
     * @param {string|null} username 用户名
     * @param {string|null} telephone 手机号
     * @param {string} code 验证码
     * @returns {*}
     */
    checkCheckCode:function (username,telephone,code) {
        console.log('api:checkCheckCode  --','data: ',`telephone:${telephone},username:${username},code:${code}`);
        let data = null;
        if (username!==null) data = {username,code};
        else if(telephone!==null) data = {telephone,code};
        return request({
            url:'api/Login/checkcode',
            method:'post',
            data:data
        });
    },
    /**
     * @param {string|null} newpassword 新密码
     * @param {string|null} username 用户名
     * @param {string|null} oldpassword 旧密码
     */
    changePassWord:function (newpassword,username,password) {
        console.log('收到的数据','旧密码',newpassword,'用户名',username,'新密码',password)
        return request({
            url:'/api/Account/mdpssd',
            method:'post',
            data: {newpassword,username,password}
        });
    },
    /**
     * 注销账号
     * @param username 用户名
     * @param password 密码
     * @param code 验证码
     * @param telephone 手机号
     * @returns {*}
     */
    offAccount:function (username,password,code,telephone) {
        console.log(username,password,code)
        return request({
            url:'api/Account/accntdel',
            method:'post',
            data: {username,password,code,telephone}
        });
    }
    //endregion
}

export default api;
